import ApiService from "@/ts/core/services/ApiService";
import { RecruitProposalStatus } from "@/ts/enums/RecruitProposalStatus";
/**
 * 로그인 사용자의 받은 제안 통계를 조회하여
 * navbar / 모바일 메인의 대기중(pending) 알람 카운트를 표시
 */
var applyPendingCount = function (count) {
    var hasNoti = count > 0;
    document
        .querySelectorAll(".js-proposal-pending-count")
        .forEach(function (el) {
        el.textContent = String(count);
    });
    document
        .querySelectorAll(".js-proposal-bell")
        .forEach(function (el) {
        el.style.display = hasNoti ? "" : "none";
    });
    document
        .querySelectorAll(".js-proposal-noti-target")
        .forEach(function (el) {
        el.classList.toggle("has-noti", hasNoti);
    });
};
var renderPendingProposalCount = function () {
    if (!window.user)
        return;
    ApiService.query("".concat(process.env.MIX_API_HOST, "/recruit-proposal/statistics"), {})
        .then(function (_a) {
        var _b;
        var data = _a.data;
        var statistics = (_b = data === null || data === void 0 ? void 0 : data.data) !== null && _b !== void 0 ? _b : [];
        var pending = statistics.find(function (item) { return item.status === RecruitProposalStatus.PENDING; });
        applyPendingCount(pending ? Number(pending.count) : 0);
    })
        .catch(function (error) {
        console.error("받은 제안 카운트 조회 실패", error);
    });
};
// pageshow는 최초 로드뿐 아니라 bfcache(뒤로/앞으로 가기) 복원 시에도 발생하므로
// 뒤로가기로 돌아왔을 때도 카운트를 다시 조회해 갱신한다.
window.addEventListener("pageshow", renderPendingProposalCount);
